"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backendOrderSheet = void 0;
var utils_1 = require("../../utils");
exports.backendOrderSheet = function (axios) {
    return {
        postOrderSheets: function (request) {
            return axios.post('/order-sheets', request.data);
        },
        getOrderSheetsOrderSheetNo: function (request) {
            var url = utils_1.paramPathchange('/order-sheets/{orderSheetNo}', request);
            return axios.get(url, request);
        },
        getOrderSheetsOrderSheetNoCoupons: function (request) {
            var url = utils_1.paramPathchange('/order-sheets/{orderSheetNo}/coupons', request);
            return axios.get(url, request);
        },
        postOrderSheetsOrderSheetNoCalculate: function (request) {
            var url = utils_1.paramPathchange('/order-sheets/{orderSheetNo}/calculate', request);
            return axios.post(url, request.data);
        },
        postOrderSheetOrderSheetNoCouponsApply: function (request) {
            var url = utils_1.paramPathchange('/order-sheets/{orderSheetNo}/coupons/apply', request);
            return axios.post(url, request.data);
        },
        postOrderSheetsOrderSheetNoCouponsCalculate: function (request) {
            var url = utils_1.paramPathchange('/order-sheets/{orderSheetNo}/coupons/calculate', request);
            return axios.post(url, request.data);
        }
    };
};
